import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Minibusonrentinpune() {



    const cardData =
    {
        keyword: 'Mini Bus On Rent in Pune',
        heading: 'Urbania on rent in pune: Mini Bus On Rent in Pune',
        headingDescription: 'Urbania On Rent in Pune offers premium and dependable Mini Bus On Rent in Pune services for corporate groups, families, tourists, and event travelers seeking comfortable and spacious group transportation across the city and nearby destinations. Our well-maintained Force Urbania mini bus fleet provides generous seating capacity, air-conditioned comfort, and smooth performance, making it ideal for airport transfers, corporate travel, weddings, sightseeing tours, local trips, and outstation journeys from Pune. With professional chauffeurs, flexible one-way and round-trip rental options, and convenient doorstep pickup from major areas including Hinjewadi, Baner, Wakad, Kharadi, Hadapsar, Kothrud, Pimpri Chinchwad, and Pune Airport, we ensure a safe, punctual, and stress-free travel experience. Backed by 24/7 booking support, transparent pricing, and trusted service, Urbania On Rent in Pune stands out as the trusted choice for mini bus hire in Pune.',

        top: 'Top Places to Visit in Pune with Urbania on rent in pune',


"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is Pune’s most iconic historical landmark, built in 1732 by Peshwa Bajirao I as the seat of Maratha power. Known for its massive stone walls, grand gates like Delhi Darwaza, and spacious courtyards, the fort reflects the glory of the Peshwa era. Though a fire destroyed much of the structure, its ruins still narrate stories of bravery, politics, and royal life. The evening light and sound show vividly brings Maratha history to life, making it a must-visit heritage attraction."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is a majestic monument deeply connected to India’s freedom struggle. Built in 1892, it served as a prison for Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai during the Quit India Movement. The palace now functions as a memorial and museum showcasing personal belongings, photographs, and letters of Gandhiji. Surrounded by lush lawns and Italian-style arches, it offers a peaceful and historically enriching experience."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort stands atop a hill in the Sahyadri range and is famous for the legendary battle fought by Tanaji Malusare for Chhatrapati Shivaji Maharaj. The fort offers breathtaking views of valleys, dams, and surrounding mountains. Popular among trekkers, history lovers, and nature enthusiasts, Sinhagad also offers local Maharashtrian food like pithla-bhakri at the top. It perfectly combines adventure, history, and scenic beauty."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered spiritual landmark dedicated to Lord Ganesha. The beautifully adorned idol attracts thousands of devotees daily and lakhs during Ganesh Chaturthi. The temple trust is also known for its social and charitable work. The festive atmosphere, devotion, and cultural significance make it the spiritual heart of Pune."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill is one of the oldest heritage sites in Pune, offering panoramic views of the entire city. After climbing 103 stone steps, visitors reach the Parvati Temple complex built during the Peshwa period. The hill also houses a small museum and several ancient shrines. Sunrise and sunset views from Parvati Hill are especially popular among photographers and peace seekers."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an 8th-century rock-cut temple dedicated to Lord Shiva, carved from a single basalt rock. Located in the heart of the city, it provides a calm and spiritual escape from urban chaos. The temple features monolithic pillars, a Nandi mandap, and ancient carvings showcasing early Indian craftsmanship. It is a hidden heritage gem of Pune."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a cultural treasure trove displaying over 20,000 artifacts collected from across India. The museum showcases traditional utensils, musical instruments, sculptures, weapons, paintings, and everyday objects from ancient Indian households. The recreated Mastani Mahal is a major highlight. It offers deep insight into India’s artistic and cultural heritage."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Located in Koregaon Park, the Osho International Meditation Resort is a globally renowned center for meditation, mindfulness, and wellness. Spread across serene gardens, it attracts visitors from all over the world seeking inner peace and relaxation. The resort offers meditation sessions, therapies, and spiritual programs in a calm and luxurious environment."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped garden. It features flowing water streams, arched bridges, manicured lawns, and seasonal flowers. Ideal for families, couples, and photographers, the garden offers a peaceful escape amidst greenery and beautifully designed landscapes."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam is a popular leisure spot located on the outskirts of Pune. The vast water reservoir, surrounding hills, and cool breezes make it especially attractive during monsoon and evenings. Visitors enjoy scenic views, street food stalls, and relaxed outings with friends and family. It also serves as the gateway to Sinhagad Fort."
  },
  {
    "title": "Vetal Tekdi",
    "description": "Vetal Tekdi is Pune’s highest hill and a green paradise within the city limits. Known for morning walks, cycling, and bird watching, it offers beautiful views of Pune’s skyline and surrounding hills. The quiet environment and fresh air make it a favorite spot for fitness enthusiasts and nature lovers."
  },
  {
    "title": "Bund Garden",
    "description": "Bund Garden is a scenic riverside garden located near the Mula-Mutha River. It is a popular spot for evening walks, jogging, and relaxation. The well-maintained lawns, flower beds, and calm atmosphere make it ideal for families and couples. Boat Club Road nearby adds to its charm."
  }
],






"services": [
{
"name": "Mini Bus on Rent in Pune",
"description": "Mini Bus on Rent in Pune offers well-maintained mini buses for local and outstation travel. Ideal for families, corporate groups, and tourists, these buses provide comfortable seating, professional chauffeurs, and a hassle-free travel experience across Pune and nearby destinations."
},
{
"name": "Mini Bus Hire Pune",
"description": "Mini Bus Hire Pune provides convenient rental options for city travel, sightseeing tours, and group outings. With AC and non-AC options, these buses ensure a safe, comfortable, and timely journey for all passengers."
},
{
"name": "AC Mini Bus Rental Pune",
"description": "AC Mini Bus Rental Pune offers air-conditioned mini buses for comfortable city and long-distance travel. Equipped with modern interiors and professional drivers, these buses provide a relaxing and enjoyable travel experience."
},
{
"name": "Non AC Mini Bus Pune",
"description": "Non AC Mini Bus Pune provides budget-friendly travel options without compromising on safety and comfort. Perfect for local sightseeing, group tours, and family outings within and around Pune."
},
{
"name": "Corporate Mini Bus Hire Pune",
"description": "Corporate Mini Bus Hire Pune delivers professional transport solutions for business travel, office events, and corporate outings. Features include punctual service, trained drivers, and comfortable seating for executive travel."
},
{
"name": "Mini Bus for Wedding Pune",
"description": "Mini Bus for Wedding Pune offers spacious and elegant buses to transport wedding guests and family members. Ensures punctuality, comfort, and convenience for special wedding celebrations."
},
{
"name": "Mini Bus for Outstation Pune",
"description": "Mini Bus for Outstation Pune provides AC and non-AC buses for long-distance trips, weekend getaways, and sightseeing tours. Passengers enjoy comfortable seating, luggage support, and courteous drivers familiar with the routes."
},
{
"name": "Mini Bus Airport Transfer Pune",
"description": "Mini Bus Airport Transfer Pune offers timely pick-up and drop services to and from Pune Airport. Ideal for tourists, corporate travelers, and families seeking a stress-free and comfortable airport transfer experience."
},
{
"name": "Luxury Mini Bus Pune",
"description": "Luxury Mini Bus Pune provides high-end mini buses with plush seating, modern interiors, and professional drivers. Perfect for VIP travel, family trips, and corporate outings seeking comfort and style."
},
{
"name": "Affordable Mini Bus Hire Pune",
"description": "Affordable Mini Bus Hire Pune delivers budget-friendly mini bus rental options for city travel, local sightseeing, and group outings without compromising on safety, convenience, or comfort."
},
{
"name": "Chauffeur Driven Mini Bus Pune",
"description": "Chauffeur Driven Mini Bus Pune ensures a smooth and stress-free journey with verified and experienced drivers. Ideal for families, corporate groups, and tourists seeking safe and reliable travel across Pune."
},
{
"name": "Mini Bus for Group Travel Pune",
"description": "Mini Bus for Group Travel Pune offers large-capacity mini buses for friends, families, and corporate groups. Ensures safe, comfortable, and convenient transport for group outings, excursions, and tours."
},
{
"name": "Best Mini Bus Rental Pune",
"description": "Best Mini Bus Rental Pune provides top-rated mini buses with excellent customer service, timely pickups, and a comfortable travel experience for both local and outstation trips."
},
{
"name": "Mini Bus for Picnic Pune",
"description": "Mini Bus for Picnic Pune delivers spacious and reliable buses for family picnics, school outings, and group excursions. Features comfortable seating, luggage support, and professional drivers for a seamless experience."
},
{
"name": "Reliable Mini Bus Service Pune",
"description": "Reliable Mini Bus Service Pune offers dependable and punctual mini bus services for city and outstation travel. Known for safety, comfort, and professional drivers, making group travel smooth and enjoyable."
}
],
"tableData": [
["Mini Bus on Rent in Pune", "Mini Bus Hire Pune"],
["AC Mini Bus Rental Pune", "Non AC Mini Bus Pune"],
["Corporate Mini Bus Hire Pune", "Mini Bus for Wedding Pune"],
["Mini Bus for Outstation Pune", "Mini Bus Airport Transfer Pune"],
["Luxury Mini Bus Pune", "Affordable Mini Bus Hire Pune"],
["Chauffeur Driven Mini Bus Pune", "Mini Bus for Group Travel Pune"],
["Best Mini Bus Rental Pune", "Mini Bus for Picnic Pune"],
["Reliable Mini Bus Service Pune", ""]
],



"whychoose": [
    {
        "WhyChooseheading": "Mini Bus On Rent in Pune",
        "WhyChoosedescription": "Mini Bus On Rent in Pune is ideal for small group travel, family outings, corporate trips, weddings, and short-distance journeys, offering comfortable seating and convenience."
    },
    {
        "WhyChooseheading": "Spacious and Well-Equipped Mini Buses",
        "WhyChoosedescription": "Mini Bus On Rent in Pune provides modern vehicles with air-conditioning, ample legroom, and comfortable seating for a smooth travel experience."
    },
    {
        "WhyChooseheading": "Professional and Experienced Drivers",
        "WhyChoosedescription": "All mini buses come with trained drivers familiar with Pune and nearby routes, ensuring safe, punctual, and hassle-free travel."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Mini Bus On Rent in Pune offers competitive rates with no hidden charges, making group and family travel budget-friendly."
    },
    {
        "WhyChooseheading": "24/7 Booking and Customer Support",
        "WhyChoosedescription": "Mini Bus On Rent in Pune provides round-the-clock booking assistance and support for inquiries, reservations, and last-minute travel needs."
    },
    {
        "WhyChooseheading": "Flexible Rental Packages",
        "WhyChoosedescription": "Mini Bus On Rent in Pune is available for hourly rentals, full-day bookings, multi-day trips, corporate travel, sightseeing tours, and customized packages."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Vehicles",
        "WhyChoosedescription": "All mini buses are regularly cleaned, sanitized, and maintained to ensure passenger safety and comfort."
    },
    {
        "WhyChooseheading": "Punctual and Reliable Service",
        "WhyChoosedescription": "Mini Bus On Rent in Pune guarantees on-time pickups and dependable service, ensuring smooth and stress-free travel experiences."
    }
]
}

const faqData = [
    {
        question: 'Is Mini Bus On Rent in Pune available for local and outstation travel?',
        answer: 'Yes, Mini Bus On Rent in Pune can be booked for city travel, corporate trips, family outings, and short-distance journeys.',
    },
    {
        question: 'How can I book Mini Bus On Rent in Pune?',
        answer: 'You can book Mini Bus On Rent in Pune via phone, WhatsApp, or online for quick and easy reservations.',
    },
    {
        question: 'Why choose Mini Bus On Rent in Pune?',
        answer: 'Mini Bus On Rent in Pune offers spacious seating, professional drivers, clean vehicles, and transparent pricing for corporate, family, and group travel.',
    },
    {
        question: 'Are drivers experienced?',
        answer: 'Yes, all drivers for Mini Bus On Rent in Pune are licensed, trained, and experienced in handling mini buses safely.',
    },
    {
        question: 'Can I customize pickup and drop-off locations?',
        answer: 'Absolutely. Mini Bus On Rent in Pune allows flexible pickup and drop locations across Pune and nearby areas.',
    },
    {
        question: 'Is Mini Bus On Rent in Pune available 24x7?',
        answer: 'Yes, Mini Bus On Rent in Pune operates 24x7 to meet your travel needs anytime.',
    },
    {
        question: 'Are hygiene and safety standards maintained?',
        answer: 'Yes, all mini buses are regularly sanitized, cleaned, and maintained to ensure passenger safety and comfort.',
    },
    {
        question: 'What payment options are available?',
        answer: 'Mini Bus On Rent in Pune accepts UPI, digital wallets, credit/debit cards, bank transfers, and corporate billing options.',
    },
    {
        question: 'Is customer support available during trips?',
        answer: 'Yes, dedicated customer support is available throughout your journey for smooth and stress-free travel.',
    },
    {
        question: 'Can Mini Bus be used for corporate, family, and group trips?',
        answer: 'Yes, Mini Bus On Rent in Pune is ideal for corporate outings, family trips, and small group travel.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Abhijit Patil',
        feedback: 'Mini Bus On Rent in Pune provided a comfortable and convenient ride for our family outing. Highly recommended.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Sneha Deshmukh',
        feedback: 'We booked a mini bus for a corporate trip. The vehicle was clean, spacious, and the service was excellent.',
        rating: 5,
    },
    {
        id: 3,
        name: 'Mr. Rakesh Kulkarni',
        feedback: 'Mini Bus On Rent in Pune made our group travel easy and hassle-free. Great service and punctual drivers.',
        rating: 5,
    },
];
































































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Urbania On Rent Pune", link: "urbania-on-rent-pune" },
        { place: "/images/keyword/2.jpg", text: "Urbania on Rent in Pimpri Chinchwad", link: "urbania-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/3.jpg", text: "Urbania Hire for Corporate Events in Pune", link: "urbania-hire-for-corporate-events-in-pune" },
        { place: "/images/keyword/4.jpg", text: "17 Seater Urbania on Rent in Pune", link: "17-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/5.jpg", text: "14 Seater Urbania on Rent in Pune", link: "14-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/6.jpg", text: "Urbania on Rent in Kharadi", link: "urbania-on-rent-in-kharadi" },
        { place: "/images/keyword/7.jpg", text: "Urbania on Rent in Hadapsar", link: "urbania-on-rent-in-hadapsar" },
        { place: "/images/keyword/8.jpg", text: "Urbania on Rent in Kothrud", link: "urbania-on-rent-in-kothrud" },
        { place: "/images/keyword/9.jpg", text: "Urbania On Rent in Bibwewadi", link: "urbania-on-rent-in-bibwewadi" },
        { place: "/images/keyword/10.jpg", text: "Urbania on Rent in Koregaon Park", link: "urbania-on-rent-in-koregaon-park" },
        { place: "/images/keyword/11.jpg", text: "Urbania On Rent in Kalyani Nagar", link: "urbania-on-rent-in-kalyani-nagar" },
        { place: "/images/keyword/12.jpg", text: "Urbania On Rent in Mundhwa Pune", link: "urbania-on-rent-in-mundhwa-pune" },
        { place: "/images/keyword/13.jpg", text: "Urbania Bus On Rent in Baner", link: "urbania-bus-on-rent-in-baner" },
        { place: "/images/keyword/14.jpg", text: "Urbania AC Bus On Rent in Aundh", link: "urbania-ac-bus-on-rent-in-aundh" },
        { place: "/images/keyword/15.jpg", text: "Urbania Bus On Rent in Hinjewadi", link: "urbania-bus-on-rent-in-hinjewadi" },
        { place: "/images/keyword/16.jpg", text: "Urbania on Rent in Bhosari", link: "urbania-on-rent-in-bhosari" },
        { place: "/images/keyword/17.jpg", text: "Urbania on Rent in Pune Station", link: "urbania-on-rent-in-pune-station" },
        { place: "/images/keyword/18.jpg", text: "Urbania On Rent in Chakan", link: "urbania-on-rent-in-chakan" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Moshi", link: "urbania-on-rent-in-moshi" },
        { place: "/images/keyword/20.jpg", text: "Urbania On Rent in Charholi Budruk", link: "urbania-on-rent-in-charholi-budruk" },
        { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Nigdi Pradhikaran", link: "urbania-on-rent-in-nigdi-pradhikaran" },
        { place: "/images/keyword/22.jpg", text: "Urbania On Rent in Lohegaon", link: "urbania-on-rent-in-lohegaon" },
        { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Wagholi", link: "urbania-on-rent-in-wagholi" },
        { place: "/images/keyword/24.jpg", text: "Urbania Rental Service in Pune", link: "urbania-rental-service-in-pune" },
        { place: "/images/keyword/25.jpg", text: "Best Urbania on Rent in Pune", link: "best-urbania-on-rent-in-pune" }
    ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mini Bus On Rent in Pune",
  "image": "https://urbaniaonrentpune.in/assets/images/mini-bus-pune.jpg",
  "description": "Mini Bus On Rent in Pune provides AC and non-AC mini buses for corporate travel, weddings, outstation trips, airport transfers, picnics, and group travel. Chauffeur-driven mini buses ensure safe, comfortable, and affordable transportation across Pune and nearby locations.",
  "brand": {
    "@type": "Brand",
    "name": "Urbania on Rent in Pune"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "950",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3500",
    "availability": "https://schema.org/InStock",
    "url": "https://urbaniaonrentpune.in/mini-bus-on-rent-pune"
  }
};









    return (
        <div>
<Helmet>
  <title>
    Call:+91 9209423113 | Mini Bus On Rent in Pune | AC & Non AC Mini Bus Hire 
  </title>

  <meta
    name="description"
    content="Book Mini Bus On Rent in Pune for corporate travel, weddings, airport transfers, picnics, outstation trips, and group travel. AC and non-AC mini buses with chauffeur-driven service provide safe, comfortable, and affordable transportation in Pune."
  />

  <meta
    name="keywords"
    content="Mini Bus on Rent in Pune, Mini Bus Hire Pune, AC Mini Bus Rental Pune, Non AC Mini Bus Pune, Corporate Mini Bus Hire Pune, Mini Bus for Wedding Pune, Mini Bus for Outstation Pune, Mini Bus Airport Transfer Pune, Luxury Mini Bus Pune, Affordable Mini Bus Hire Pune, Chauffeur Driven Mini Bus Pune, Mini Bus for Group Travel Pune, Best Mini Bus Rental Pune, Mini Bus for Picnic Pune, Reliable Mini Bus Service Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <div
                className="breadcumb-wrapper"
                
                data-overlay="black"
                data-opacity="3"
            >
                <div className="container">
                    <div className="breadcumb-content text-center">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/76.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>



                            <div className="shambhu-services">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="sh-service-card">

                                        <div className="sh-service-left">
                                            <div className="sh-service-icon">
                                                🚌
                                            </div>
                                        </div>

                                        <div className="sh-service-content">
                                            <h4 className="sh-service-title">{service.name}</h4>
                                            <p className="sh-service-desc">{service.description}</p>
                                        </div>

                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Urbania On rent in Pune </span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Urbania on rent in Pune </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919209423113" className="pc-call">+91 9209423113</a>
                                            <a href="tel:+917620411277 " className="pc-call">+91 7620411277 </a>
                                            <a href="tel:+919284718314" className="pc-call">+91 9284718314</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919209423113"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919209423113" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@urbaniaonrentpune.in" className="pc-email">
                                            booking@urbaniaonrentpune.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Urbania on rent in pune</strong><br />
                                            Saket Tata Power CHS, Swami Samarth Marg,
                                            Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                                            Maharashtra India - 400703
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Minibusonrentinpune;